import {DISTRIBUTE_TO_BANK_ID, DISTRIBUTE_TO_FUND_ID} from "services/Preferences";
import { isNull, isUndefined } from 'lodash';

export const fundInfo = (availableFunds, fundId) => {
    return availableFunds.find(
        (acc) => acc.accountId === fundId
    )
};


export const bankInfo = (associatedBanksFromFund, bankAgreementKey) => {
    return associatedBanksFromFund.find(
        (bank) => bank.bankAgreementKey.bankId === bankAgreementKey
    )
};


export const checkIfMissingFundOrBank = (
    capitalGainsDistributionTypeId,
    dividendsDistributionTypeId,
    capitalGainsBankAgreementKey,
    dividendsBankAgreementKey,
    dividendsFund,
    capitalGainsFund
) => {
    if (
        capitalGainsDistributionTypeId === DISTRIBUTE_TO_BANK_ID &&
        !capitalGainsBankAgreementKey
    ) {
        return true;
    } else if (
        dividendsDistributionTypeId === DISTRIBUTE_TO_BANK_ID &&
        !dividendsBankAgreementKey
    ) {
        return true;
    } else if (dividendsDistributionTypeId === DISTRIBUTE_TO_FUND_ID && !dividendsFund) {
        return true;
    } else if (
        dividendsDistributionTypeId === DISTRIBUTE_TO_FUND_ID &&
        !capitalGainsFund
    ) {
        return true;
    } else {
        return false;
    }
};

export const checkIfMissingDistributionAccountId = (distribution) => {
    return (
        isNull(distribution) ||
        isUndefined(distribution) ||
        isNull(distribution.fundInfo) ||
        isUndefined(distribution.fundInfo) ||
        isNull(distribution.fundInfo.accountDescriptor) ||
        isUndefined(distribution.fundInfo.accountDescriptor) ||
        isNull(distribution.fundInfo.accountDescriptor.accountId) ||
        isUndefined(distribution.fundInfo.accountDescriptor.accountId)
    );
};
